module.exports = __webpack_public_path__ + "img/lower.95c89668.png";